const TracerMappingHeader = () => {
  return (
    <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
      <div className="flex w-3/12 pl-10 items-center">DTC Name</div>
      <div className="flex w-4/12 pl-6 items-center">Description</div>
      <div className="flex w-2/12 pl-6 items-center">ECU</div>
      <div className="flex w-2/12 pl-6 items-center">Updated</div>
      <div className="flex w-1/12 pl-6 items-center">Action</div>
    </div>
  )
}

export default TracerMappingHeader
